'use client'

import { forwardRef, type ComponentProps } from 'react'
import Link from 'next/link'
import { useResolveExternalHref } from '@/lib/wmtAppPlatform/useResolveExternalHref'

export type WrapperLinkProps = Omit<ComponentProps<typeof Link>, 'href'> & {
    href: string
    /** Pass through to `resolveExternalHref` (e.g. same-origin `target="_blank"` exits). */
    openExternally?: boolean
}

/**
 * Next.js `Link` that resolves `href` through the native-app deeplink helper
 * when enabled. Does not change target/rel defaults.
 */
export const WrapperLink = forwardRef<HTMLAnchorElement, WrapperLinkProps>(
    function WrapperLink({ href, openExternally, ...props }, ref) {
        const resolveExternalHref = useResolveExternalHref()

        return (
            <Link
                ref={ref}
                href={resolveExternalHref(href, { openExternally })}
                {...props}
            />
        )
    },
)
